import { gql } from 'apollo-boost';

export const SEARCH_STUDENTS_FOR_BOOMBASSADOR = gql`
query studentsSearchForBoombassador($name: String!) {
    studentsSearchForBoombassador(name: $name) {
        id
        firstName
        lastName
        avatarJson
        updatedAt
        boomerAvatarUrl
        readingBooks {
            addedBy {
                id
                displayName
            }
            id
            status
            bookType
            logs {
                id
                date
            }
            book {
                id
                author
                description
                title
                coverUrl
                isbn
                isbn13
            }
        }
        classes {
            id
            name
            typeId
        }
    }
}
`;

export const ACCEPT_BOOMBASSADOR_ROLE = gql`
mutation acceptBoombassadorRole {
    acceptBoombassadorRole {
        accepted
        errors
    }
}
`;

